import React from "react"

const Prose = ({ children }) => (
  <article className="prose prose-neutral prose-lg max-w-none prose-green prose-a:text-green-700 dark:prose-a:text-green-400 dark:prose-invert dark:prose-hr:border-neutral-600 dark:prose-tr:border-neutral-600">
    {children}
  </article>
)

export default Prose
